import _, { cloneDeep, set } from "lodash";

function updateBlockForEvaluationAndFeedback(block: any, responseData: any) {
    const { evaluation, feedback, variables } = responseData;

    let functionsList: any[] = [];

    const evaluationFunction = evaluation?.evaluate?.function;
    const feedbackFunction = feedback?.fullCode;
    const getConditionCorrectFunction = evaluation?.getConditionCorrect;
    const variableFunctions = variables?.functions || {};

    let newBlock = cloneDeep(block);

    const conditionsIndex = newBlock?.data?.all_in_one?.components?.findIndex(
        (component: any) => component?.type === "condition",
    );

    const interactiveTableIndex =
        newBlock?.data?.all_in_one?.components?.findIndex((i: any) => {
            if (i.type === "generic_table") {
                return !i.skip_evaluation && !i.disable_interaction;
            }
            return false;
        });

    if (conditionsIndex !== -1) {
        functionsList.push({
            name: "getConditionCorrect",
            output: getConditionCorrectFunction,
        });
        const getConditionCorrectIndex =
            newBlock?.data?.all_in_one?.components?.[
                conditionsIndex
            ]?.data?.compute_functions?.findIndex(
                (i: any) => i?.name === "getConditionCorrect",
            );
        if (getConditionCorrectIndex !== -1) {
            set(
                newBlock,
                `data.all_in_one.components[${conditionsIndex}].data.compute_functions[${getConditionCorrectIndex}].output`,
                getConditionCorrectFunction,
            );
        }
    }

    if (interactiveTableIndex !== -1) {
        const tableAndTagsIndex = newBlock?.data?.all_in_one?.components?.[
            interactiveTableIndex
        ]?.figma?.variables?.findIndex(
            (i: any) => i?.name === "table_and_tags",
        );
        const tableCollectionIndex = newBlock?.data?.all_in_one?.components?.[
            interactiveTableIndex
        ]?.figma?.variables[tableAndTagsIndex]?.value?.findIndex(
            (i: any) => i?.type === "table_collection",
        );
        const tableDataVariableIndex = newBlock?.data?.all_in_one?.components?.[
            interactiveTableIndex
        ]?.figma?.variables[tableAndTagsIndex]?.value[
            tableCollectionIndex
        ]?.props?.table?.value?.variables?.value?.variables?.findIndex(
            (i: any) => i?.name === "tableData",
        );

        if (tableDataVariableIndex !== -1) {
            functionsList.push({
                name: "evaluate",
                output: evaluationFunction,
            });
            functionsList.push({
                name: "feedback",
                output: feedbackFunction,
            });

            // Use lodash set for nested updates
            const basePath = `data.all_in_one.components[${interactiveTableIndex}].figma.variables[${tableAndTagsIndex}].value[${tableCollectionIndex}].props.table.value.variables.value.variables[${tableDataVariableIndex}].value`;

            // Update evaluation function
            set(
                newBlock,
                `${basePath}.evaluation.function`,
                evaluationFunction,
            );

            // Update feedback function
            set(newBlock, `${basePath}.feedback.function`, feedbackFunction);
        }

        // const evaluateIndex = newBlock?.data?.all_in_one?.components?.[interactiveTableIndex]?.data?.functions?.findIndex((i) => i?.name === "evaluate");
    }

    if (Object.keys(variableFunctions).length > 0) {
        newBlock.backend.question_derived_variables = Object.keys(
            variableFunctions,
        ).map((key: any) => {
            const functionValue = variableFunctions[key];
            functionsList.push({
                name: key,
                output: functionValue,
            });
            return {
                name: key,
                computeFunction: {
                    output: functionValue,
                    params: {},
                },
            };
        });
    }

    console.log("newBlock---", newBlock, getConditionCorrectFunction);

    return { updatedBlock: newBlock, functionsList };
}

export default updateBlockForEvaluationAndFeedback;
